<template>
	<slot name="trigger" :open-drawer="openDrawer" :close-drawer="closeDrawer" :toggle-drawer="toggleDrawer"></slot>
	<Teleport to="#app">
		<div class="fixed z-20 inset-0" :class="{ 'cursor-close': showCloseCursor }" v-cloak v-if="drawerOpen"></div>
		<Transition
			enter-from-class="translate-x-[calc(100%_+_theme(spacing.12))]"
			leave-to-class="translate-x-[calc(100%_+_theme(spacing.12))]"
			enter-active-class="transition-transform duration-700 ease-out"
			leave-active-class="transition-transform duration-700 ease-in"
		>
			<div id="nav-drawer" class="fixed z-50 inset-y-0 right-0" ref="drawer" v-cloak v-if="drawerOpen" v-click-outside="closeDrawer">
				<div class="absolute inset-y-0 bg-blue-500 w-56 -left-12 rounded-24 before:absolute before:inset-y-0 before:bg-yellow-400 before:w-56 before:left-4 before:rounded-24 after:absolute after:inset-y-0 after:bg-red-500 after:w-56 after:left-8 after:rounded-24"></div>
				<div class="relative h-full bg-black bg-grid rounded-l-24 overflow-hidden before:inset-x-0 maxg:before:bg-[bottom_left] maxg:before:translate-x-0 maxg:pr-[calc((mod((100vw_-_(100vw_/var(--grid-size-unitless))),_var(--grid-size)_*_2))_/_2)]">
					<div class="absolute inset-y-0 left-0 w-800 bg-gradient-to-r from-black to-black/0 rounded-l-24"></div>
					<div class="absolute inset-x-0 top-0 ~mob/tab:~h-80/104 flex items-center justify-end ~mob/tab:~px-20/32 *:z-10">
						<slot name="menu" :open-drawer="openDrawer" :close-drawer="closeDrawer" :toggle-drawer="toggleDrawer"></slot>
					</div>
					<div class="relative w-g11 sm:w-g9 md:w-g8 tab:w-g6 h-full px-g1 pb-g1 pt-72 flex flex-col">
						<slot name="content"></slot>
					</div>
				</div>
			</div>
		</Transition>
		<Transition
			enter-from-class="!-right-552"
			leave-to-class="!-right-552"
			enter-active-class="transition-[right] duration-700 ease-out"
			leave-active-class="transition-[right] duration-700 ease-in"
		>
			<div class="fixed z-40 inset-y-0 right-[calc(var(--nav-drawer-width)-theme(spacing.24))] w-552 bg-gradient-to-l from-blue-700/45 to-blue-700/0 mix-blend-difference pointer-events-none" v-cloak v-if="drawerOpen"></div>
		</Transition>
	</Teleport>
</template>

<script setup>
import { ref, useTemplateRef, watch, nextTick, onUnmounted } from "vue";
import { mutations } from "@js/vue/store.js";
import { lock, unlock } from "@js/body-scroll-lock.js";

const drawerOpen = ref(false);

function openDrawer() {
	drawerOpen.value = true;
}

function closeDrawer() {
	drawerOpen.value = false;
}

function toggleDrawer() {
	drawerOpen.value = !drawerOpen.value;
}

const drawer = useTemplateRef('drawer')

function updateNavDrawerWidth() {
	if (drawer.value) {
		mutations.changeNavDrawerWidth(drawer.value.offsetWidth);
	}
}

const showCloseCursor = ref(false);

watch(drawerOpen, async (newValue) => {
	if (newValue) {
		lock();
		// Wait for next tick to ensure DOM is updated
		await nextTick();
		updateNavDrawerWidth();
		setTimeout(() => {
			showCloseCursor.value = true
		}, 300)
	} else {
		unlock();
		mutations.changeNavDrawerWidth(0);
		showCloseCursor.value = false
	}
}, { immediate: true });

function handleKeydown(e) {
	if (e.key === 'Escape' && drawerOpen.value) {
		closeDrawer();
	}
}

window.addEventListener('resize', updateNavDrawerWidth);
window.addEventListener('keydown', handleKeydown);

onUnmounted(() => {
	window.removeEventListener('resize', updateNavDrawerWidth);
	window.removeEventListener('keydown', handleKeydown);
});
</script>
